import { createApiSlice } from "@common";
import {  CRUD_VERIFICATION_STATUS } from "@routes";

const apiConfig = [
  {
    name: "addVerificationStatus",
    method: "post",
    url: CRUD_VERIFICATION_STATUS,
    stateKey: "message",
  },

  {
    name: "getVerificationStatus",
    method: "get",
    url: CRUD_VERIFICATION_STATUS,
    stateKey: "data",
  },

  {
    name: "updateVerificationStatus",
    method: "put",
    url: CRUD_VERIFICATION_STATUS,
    stateKey: "message",
  },

  {
    name: "deleteVerificationStatus",
    method: "delete",
    url: CRUD_VERIFICATION_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "verificationStatus", apiConfig, customReducers);
const VerificationStatusSlice = slice;

export default VerificationStatusSlice.reducer;

export const {
  addVerificationStatus,
  getVerificationStatus,
  updateVerificationStatus,
  deleteVerificationStatus,
} = thunks;

export const { rowSelect } = actions;
